module.exports = __webpack_public_path__ + "img/banner702x176.326535e4.png";